import React, { Fragment, Component } from "react";
import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Button,
  Fieldset,
  Legend,
} from "reactstrap";
import { ConfirmAlert } from "../../../../helpers/ui/alert";
import { FileInput, generateFormData } from "../../../../helpers/ui/FileInput";
import {
  AvForm,
  AvGroup,
  AvInput,
  AvField,
  AvCheckboxGroup,
  AvCheckbox,
} from "availity-reactstrap-validation";
import Select from "react-select";

import { Link, useHistory, Redirect } from "react-router-dom";
import apiResponse from "../../../../services/apiResponse";
import CreateBloc from "./Blocs/CreateBloc";
import { accessRole } from "../../../../helpers/access_role";

var reformatEmployee = function (regions) {
  return regions.map(function (region) {
    var newObj = {};
    newObj["label"] =
      region.retired_employee_nip + " - " + region.retired_employee_name;
    newObj["value"] = region.retired_employee_uuid;
    newObj["model"] = region;
    return newObj;
  });
};

class IndexView extends Component {
  createBloc = new CreateBloc();

  constructor(props) {
    super(props);
    this.state = {
      dataForm: {
        nip: "",
        nama: "",
        unit_kerja: "",
        jabatan: "",
        tmt_jabatan: "",
        tgl_pensiun: "",
        golongan: "",
        tgl_lahir: "",
        jenis_kelamin: "",
        tmt_pensiun: "",
        usia: "",
        usia_pensiun: "",
        sisa_masa_kerja: "",
        posisi: "",
      },
      submission_uuid: "",
      employeeItems: [],
      employeeSelected: "",
    };
  }

  submitData = async () => {
    if (this.state.dataForm.document.length > 0) {
      let formData = generateFormData(this.state.dataForm, "document");
      await this.createBloc.fetchCreate(formData);
    } else {
      await this.createBloc.fetchCreate(this.state.dataForm);
    }
  };

  handlerOnSubmit = (e, values) => {
    e.preventDefault();
    this.setState({
      dataForm: {
        ...values,
      },
      confirm: true,
    });
  };

  onChangeEmployee = (employee) => {
    var model = employee.model;
    this.setState({
      employeeSelected: employee.value,
      dataForm: {
        nip: model.retired_employee_nip,
        nama: model.retired_employee_name,
        unit_kerja: model.retired_employee_work_unit_name,
        jabatan: model.retired_employee_position_name,
        tmt_jabatan: model.retired_employee_position_tmt,
        tgl_pensiun: model.retired_employee_retired_date,
        golongan: model.retired_employee_level_name,
        tgl_lahir: model.retired_employee_birth_date,
        jenis_kelamin: model.gender_name,
        usia: model.employee_age,
        usia_pensiun: model.employee_age_retired,
        sisa_masa_kerja: model.employee_work_age,
        posisi: model.retired_employee_position_name,
      },
    });
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        this.submitData();
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  componentDidMount() {
    this.createBloc.createChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            loading: false,
            success: true,
          });
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });

    this.createBloc.employeeChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            this.setState({
              employeeItems: reformatEmployee(response.result),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.createBloc.fetchEmployee();
  }

  render() {
    return (
      <Fragment>
        <Container fluid>
          <Row>
            <Col className="col-12">
              <Card className="">
                <CardBody>
                  <CardTitle>Tambah Data Pensiun</CardTitle>
                  <CardSubtitle className="mb-3">
                    Setiap isian yang bertanda (
                    <span className="text-danger">*</span>) adalah wajib diisi.
                  </CardSubtitle>
                  <hr />
                  <AvForm
                    className="needs-validation"
                    onValidSubmit={(e, values) =>
                      this.handlerOnSubmit(e, values)
                    }
                  >
                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Pilih Pegawai <span className="text-danger">*</span>
                      </label>
                      <Col md="9">
                        <Select
                          value={this.state.employeeItems.filter(
                            (option) =>
                              option.value === this.state.employeeSelected
                          )}
                          onChange={this.onChangeEmployee}
                          required="required"
                          options={this.state.employeeItems}
                          classNamePrefix=""
                          placeholder="Pilih Pegawai"
                        />
                        <AvField
                          name="retired_employee_uuid"
                          type="hidden"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          id="retired_employee_uuid"
                          value={this.state.employeeSelected}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        NIP
                      </label>
                      <Col md="9">
                        <AvField
                          placeholder=""
                          name="nip"
                          id="nip"
                          readonly="readonly"
                          type="text"
                          className="form-control"
                          value={this.state.dataForm.nip}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Nama
                      </label>
                      <Col md="9">
                        <AvField
                          placeholder=""
                          name="nama"
                          id="nama"
                          readonly="readonly"
                          type="text"
                          className="form-control"
                          value={this.state.dataForm.nama}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Posisi
                      </label>
                      <Col md="9">
                        <AvField
                          placeholder=""
                          name="posisi"
                          id="posisi"
                          readonly="readonly"
                          type="text"
                          className="form-control"
                          value={this.state.dataForm.posisi}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Unit Kerja
                      </label>
                      <Col md="9">
                        <AvField
                          placeholder=""
                          name="unit_kerja"
                          id="unit_kerja"
                          readonly="readonly"
                          type="text"
                          className="form-control"
                          value={this.state.dataForm.unit_kerja}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Tanggal Pensiun
                      </label>
                      <Col md="9">
                        <AvField
                          placeholder=""
                          name="tgl_pensiun"
                          id="tgl_pensiun"
                          readonly="readonly"
                          className="form-control"
                          value={this.state.dataForm.tgl_pensiun}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Sisa Masa Kerja
                      </label>
                      <Col md="9">
                        <AvField
                          placeholder=""
                          name="masa_kerja"
                          id="masa_kerja"
                          readonly="readonly"
                          type="form-control"
                          className="form-control"
                          value={this.state.dataForm.sisa_masa_kerja}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        TMT Pensiun <span className="text-danger">*</span>
                      </label>
                      <Col md="9">
                        <AvField
                          placeholder="TMT Pensiun"
                          name="tmt_pensiun"
                          id="tmt_pensiun"
                          type="date"
                          className="form-control"
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        No BKN <span className="text-danger">*</span>
                      </label>
                      <Col md="9">
                        <AvField
                          placeholder="Nomor BKN"
                          name="no_bkn"
                          id="no_bkn"
                          type="form-control"
                          className="form-control"
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Tanggal BKN <span className="text-danger">*</span>
                      </label>
                      <Col md="9">
                        <AvField
                          placeholder="Tanggal BKN"
                          name="tgl_bkn"
                          id="tgl_bkn"
                          type="date"
                          className="form-control"
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Nomor SK Pensiun <span className="text-danger">*</span>
                      </label>
                      <Col md="9">
                        <AvField
                          placeholder="Nomor SK Pensiun"
                          name="no_sk_pensiun"
                          id="no_sk_pensiun"
                          type="form-control"
                          className="form-control"
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        File SK <span className="text-danger">*</span>
                      </label>
                      <Col md="9">
                        <FileInput name="document" />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Col md="3"></Col>
                      <Col md="9">
                        <Link to="/kepegawaian/pensiunsk.html">
                          <Button color="danger">
                            <i className="uil-arrow-left"></i> Kembali
                          </Button>
                        </Link>{" "}
                        <Button color="success" type="submit">
                          <i className="uil-arrow-up-right"></i> Simpan Data
                        </Button>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo="Apakah anda yakin akan menyimpan data ini?"
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil disimpan"
          failedTitle="Gagal!"
          failedInfo="Data gagal disimpan"
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
        {this.state.redirect ? (
          <Redirect to="/kepegawaian/pensiunsk.html" />
        ) : null}
      </Fragment>
    );
  }
}

export default IndexView;
